let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GyfB")).then(() => parcelRequire('iABvk'));